import Checkbox from "PFComponents/checkbox/checkbox";
import { Typography } from "PFComponents/typography";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PreferencesFormValues } from "../edit_preferences_modal";
import css from "../edit_preferences_modal.module.scss";

type CheckboxFieldData = {
  name: keyof Pick<PreferencesFormValues, "hybridWork" | "officeWork" | "remoteWork">;
  labelKey: string;
};

const checkboxFields: CheckboxFieldData[] = [
  {
    name: "officeWork",
    labelKey: "office"
  },
  {
    name: "remoteWork",
    labelKey: "remote"
  },
  {
    name: "hybridWork",
    labelKey: "hybrid"
  }
];

export const TypeCheckboxes = (): JSX.Element => {
  const { t } = useTranslation("marketplace", { keyPrefix: "editPreferencesModal" });

  const { control } = useFormContext<PreferencesFormValues>();

  return (
    <div className={css.row}>
      <Typography variant="labelRegular" className={css.label}>
        {t("type")}
      </Typography>
      <span className={css.checkboxes}>
        {checkboxFields.map(({ name, labelKey }) => (
          <Controller
            key={name}
            name={name}
            control={control}
            render={({ field }) => (
              <Checkbox
                checked={field.value}
                handleChange={field.onChange}
                label={t(labelKey as unknown as TemplateStringsArray)}
                small={false}
                classes={{
                  inputFake: css.checkboxInputFake
                }}
              />
            )}
          />
        ))}
      </span>
    </div>
  );
};
